import React from "react"

import styles from "./ButtonContainer.module.scss"

export type ButtonContainerProps = {
	children: React.ReactNode
	className?: string
}

const ButtonContainer = ({children, className}: ButtonContainerProps) => {
	return (
		<div className={`${className}  ${styles.content_buttons_box}`}>
			{children}
		</div>
	)
}

export default ButtonContainer
